/**
 * CSS Prefix
 * MUST be in sync with CSS_PREFIX inside ./constants.ts for client side
 */
export const CSS_PREFIX = 'lvbg-';

export const LAND_TO_ELEMENT_KEY = 'landToElement';
const LOCAL_NAV_HEIGHT_MOBILE = 64;
const LOCAL_NAV_HEIGHT_DESKTOP = 67;
const SECTION_NAV_HEIGHT_DESKTOP = 61;
const SKY_PLAYER_HEIGHT_MOBILE = 232;
const TOP_MARGIN = 10;
export const RESPONSIVE_OFFSET = {
  mobile: LOCAL_NAV_HEIGHT_MOBILE + SKY_PLAYER_HEIGHT_MOBILE + TOP_MARGIN,
  desktop: LOCAL_NAV_HEIGHT_DESKTOP + SECTION_NAV_HEIGHT_DESKTOP + TOP_MARGIN,
};
